"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.castIteraction = void 0;
const castIteraction = (interaction) => {
    const [interactionId, instanceId] = interaction.split('|');
    return { interactionId, instanceId };
};
exports.castIteraction = castIteraction;
